module.exports = __webpack_public_path__ + "b17aec7cae21b9b9d50166f5b6f3ef12.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/tshirt-white.png
// module id = 814
// module chunks = 0